import React from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export function ReabrirCompetencia({ modalData }) {
  return (
    <div>
      <div>
        <span>Período</span>
        <p>{modalData && modalData?.periodo}</p>
      </div>

      <div>
        <span>Responsável</span>
        <p>{modalData && modalDataResponsavel?.nomeUsuario}</p>
      </div>

      <div>
        <span>E-mail</span>
        <p>{modalData && modalDataResponsavel?.email}</p>
      </div>

      <div>
        <span>Instituição</span>
        <p>{modalData && modalDataResponsavel?.nomeFantasia}</p>
      </div>

      <div>
        <span>Data</span>
        <p>
          {modalData &&
            modalDataResponsavel?.dataCriacao &&
            format(
              new Date(`${modalDataResponsavel.dataCriacao}`),
              'dd/MM/yyyy - HH:mm:ss',
              {
                locale: ptBR,
              }
            )}
        </p>
      </div>
    </div>
  );
}
